import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "topLogo"
}
const _hoisted_2 = {
  key: 1,
  class: "qrMobile"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "sub-ion-tabs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_help_center = _resolveComponent("help-center")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.token && !_ctx.route.path.includes('changepassword'))
        ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              class: "",
              src: "assets/mylogo.svg"
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.route.path.includes('home'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "qrAppCode" }, null, -1)),
            _createElementVNode("p", null, [
              _createElementVNode("small", {
                innerHTML: _ctx._t('{qr_code_message}')
              }, null, 8, _hoisted_3)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_help_center),
      _createVNode(_component_ion_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet, { animated: false }),
          _withDirectives(_createVNode(_component_ion_tab_bar, {
            style: _normalizeStyle(_ctx.level === 'digital' ? { height: '400px' } : {}),
            slot: "bottom",
            translucent: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_tab_button, {
                tab: "home",
                href: "/home",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "app-icon sicon-home-alt" }, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('découvrir')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [2,3]
              }),
              _withDirectives(_createVNode(_component_ion_tab_button, {
                tab: "cart",
                href: "/cart",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "app-icon sicon-cart" }, null, -1)),
                  _cache[5] || (_cache[5] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('la boutique')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [4,5]
              }, 512), [
                [_vShow, !_ctx.limited]
              ]),
              _createVNode(_component_ion_tab_button, {
                class: "no-mobile",
                tab: "orders",
                href: "/orders",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "app-icon sicon-document-stack" }, null, -1)),
                  _cache[7] || (_cache[7] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('commandes')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [6,7]
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "academy",
                href: "/digitalacademy",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "app-icon sicon-academy" }, null, -1)),
                  _cache[9] || (_cache[9] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('academy')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [8,9]
              }),
              _withDirectives(_createVNode(_component_ion_tab_button, {
                tab: "institute",
                href: "/institute",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "app-icon sicon-location" }, null, -1)),
                  _cache[11] || (_cache[11] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('Institut')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [10,11]
              }, 512), [
                [_vShow, _ctx.myrPartner && _ctx.level && _ctx.level !== 'digital' && _ctx.level !== 'distributor']
              ]),
              _withDirectives(_createVNode(_component_ion_tab_button, {
                class: "no-mobile",
                tab: "marketing",
                href: "/marketing",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("i", { class: "app-icon sicon-cloud" }, null, -1)),
                  _cache[13] || (_cache[13] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('marketing')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [12,13]
              }, 512), [
                [_vShow, _ctx.level && _ctx.level !== 'digital']
              ]),
              _createVNode(_component_ion_tab_button, {
                class: "no-mobile",
                tab: "sav",
                href: "/sav",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[14] || (_cache[14] = _createElementVNode("i", { class: "app-icon sicon-support" }, null, -1)),
                  _cache[15] || (_cache[15] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('Assistance')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [14,15]
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "company",
                href: "/company",
                routerDirection: "root"
              }, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "app-icon sicon-grid-small" }, null, -1)),
                  _cache[17] || (_cache[17] = _createTextVNode()),
                  _createVNode(_component_ion_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx._t('plus')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1,
                __: [16,17]
              })
            ]),
            _: 1
          }, 8, ["style"]), [
            [_vShow, _ctx.token && !_ctx.route.path.includes('changepassword')]
          ]),
          (_ctx.token)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}